import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BSContentService from '../../services/BSContentService';
import './GmailInfo.css';

const GMAIL_INFO_COMIC_ID = 8581656;
const GMAIL_TITLE = 'Gmail';
const GMAIL_TEXT_TOP = 'We\'ve put your avatar into the Gmail composer.';
const GMAIL_TEXT_BOT = 'Click it for easy access to your bitmojis!';
const CLICKME_TEXT_BOT = 'Click Me!';
class GmailInfo extends Component {
    render() {
        const { avatarId } = this.props;
        const templateUrl = BSContentService.getTransparentAvatarForComicId(
            GMAIL_INFO_COMIC_ID, avatarId
        );

        return (
            <a href="https://mail.google.com/mail/u/1/#inbox?compose=new" id="open-gmail-composer"
               rel="noopener noreferrer" target="_blank" className="gmail-ext-info">
                <div className="gmail-ext-header-icon">
                    <span className="gmail-ext-title">
                        <p>{GMAIL_TITLE}</p>
                    </span>
                </div>
                <div className="gmail-ext-images-wrapper">
                    <span className="gmail-ext-text">
                        <p>{GMAIL_TEXT_TOP}</p>
                        <p>{GMAIL_TEXT_BOT}</p>
                    </span>
                    <img className="gmail-ext-floater" src={templateUrl}
                         alt={templateUrl} />
                    <div className="gmail-ext-compose-window" />
                    <span className="clickme-link">
                        <p>{CLICKME_TEXT_BOT}</p>
                    </span>
                </div>
            </a>
        );
    }
}

GmailInfo.propTypes = {
    avatarId: PropTypes.string.isRequired
};

export default GmailInfo;



// WEBPACK FOOTER //
// ./src/components/congrats_view/GmailInfo.js